/**
 * Featured Podcasts for Discovery
 *
 * Curated list of popular, high-quality podcasts to display
 * in the "Streameater Recommends" hero carousel for podcasts.
 */

export interface FeaturedPodcast {
  id: string;
  name: string;
  podcastIndexId?: number; // Podcast Index Feed ID
  description: string;
  category: string;
  country: string;
  imageUrl?: string;
}

/**
 * Hand-picked podcasts for international appeal
 * Based on visitor analytics: Sweden (64%), USA (14%), UK (6%), etc.
 */
export const FEATURED_PODCASTS: FeaturedPodcast[] = [
  // TOP INTERNATIONAL SHOWS - matches seedPods.ts IDs
  {
    id: "6943047",
    name: "Huberman Lab",
    description:
      "Science-based tools for everyday life from Stanford neuroscientist Andrew Huberman.",
    category: "Science",
    country: "United States",
    imageUrl:
      "https://megaphone.imgix.net/podcasts/042e6144-725e-11ec-a75d-c38f702aecad/image/ee4f0b7b466ca35620792970d9bce2d2.jpg?ixlib=rails-4.3.1&max-w=3000&max-h=3000&fit=crop&auto=format,compress",
  },
  {
    id: "hardcore-history",
    name: "Dan Carlin's Hardcore History",
    description: "In-depth, epic looks at ancient and modern history.",
    category: "History",
    country: "United States",
    imageUrl: "https://www.dancarlin.com/graphics/DC_HH_iTunes.jpg",
  },
  {
    id: "739525",
    name: "The Tim Ferriss Show",
    description: "Deconstructing world-class performers from eclectic areas.",
    category: "Business",
    country: "United States",
    imageUrl:
      "https://content.production.cdn.art19.com/images/69/10/10/fb/691010fb-625e-4abe-993c-a57228b28dbe/91cb53ae0d5dbb379b9dffecf0a772593891d0d09bbe6d90ee746edbdb79e3ec75584f2ceb8260e9f675a90c05419b9b99842a76905b686f0f51c1a9d3e227ab.jpeg",
  },
  {
    id: "947138",
    name: "Waveform: The MKBHD Podcast",
    description:
      "A tech podcast for gadget lovers and nerds. Hosted by Marques Brownlee.",
    category: "Technology",
    country: "United States",
    imageUrl:
      "https://megaphone.imgix.net/podcasts/ae6237e6-7e71-11e9-9c4d-3b02b0eab47c/image/21_VMPN_011_Waveform_Social_3000x3000.png?ixlib=rails-4.3.1&max-w=3000&max-h=3000&fit=crop&auto=format,compress",
  },
  {
    id: "1015378",
    name: "All-In Podcast",
    description:
      "Industry veterans & besties discuss economics, tech, politics, and more.",
    category: "Business",
    country: "United States",
    imageUrl:
      "https://static.libsyn.com/p/assets/a/9/c/b/a9cb4d1dadb1ea21/all-in_logo.png",
  },
  {
    id: "387129",
    name: "99% Invisible",
    description:
      "Design is everywhere in our lives, perhaps most importantly in the places where we've just stopped noticing.",
    category: "Design",
    country: "United States",
    imageUrl:
      "https://image.simplecastcdn.com/images/8436e3c1-2479-4466-ac48-fa58259960bb/a6d5b177-ab5d-430d-b3f2-b393a09d8101/3000x3000/sxm-cover-99percentinvisible-r2025-3000x3000-final.jpg?aid=rss_feed",
  },
  {
    id: "6058902",
    name: "Latent Space",
    description:
      "The AI Engineer Podcast. Deep dives into AI, LLMs, and engineering.",
    category: "Technology",
    country: "United States",
    imageUrl:
      "https://assets.flightcast.com/static/01K4D8FDXRRRRZG0EBGNDF3SD3.jpg",
  },
  {
    id: "446951",
    name: "The MeatEater Podcast",
    description:
      "Hunting, fishing, and outdoor adventures with Steven Rinella.",
    category: "Outdoor",
    country: "United States",
    imageUrl:
      "https://www.omnycontent.com/d/playlist/e73c998e-6e60-432f-8610-ae210140c5b1/63aba8bc-2dc8-4f89-807a-ae280065a7cd/3892b9a1-a960-4f9e-bee7-ae280065a7db/image.jpg?t=1643091011&size=Large",
  },
];
